var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "rbv-dropdown",
    {
      attrs: { "is-open": _vm.open, "backdrop-style": _vm.$style.backdrop },
      on: { close: _vm.close },
    },
    [
      _c(
        "div",
        {
          class: { [_vm.$style.toggler]: true, [_vm.classes]: _vm.classes },
          style: _vm.background,
          attrs: { slot: "toggler" },
          on: { click: _vm.toggle },
          slot: "toggler",
        },
        [
          _vm.label
            ? _c("div", { class: _vm.$style.label }, [
                _vm._v(" " + _vm._s(_vm.label) + " "),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          class: _vm.$style.dropdown,
          attrs: { slot: "dropdown" },
          slot: "dropdown",
        },
        [
          _vm.label
            ? _c("div", { class: _vm.$style.label }, [_vm._v(" Color Picker ")])
            : _vm._e(),
          _c("canvas", {
            ref: "canvas",
            attrs: { width: "200", height: "200" },
            on: { click: _vm.click },
          }),
          _c("input", {
            class: _vm.$style.slider,
            attrs: { type: "range", min: "0", step: "0.01", max: "1" },
            domProps: { value: _vm.canvas.alpha },
            on: { input: _vm.changeAlpha },
          }),
          _c("div", { class: _vm.$style.controls }, [
            _c("div", { class: _vm.$style.inputContainer }, [
              _c("div", { class: _vm.$style.colorSpot, style: _vm.background }),
              _c("input", {
                class: _vm.$style.input,
                domProps: { value: _vm.value },
                on: { input: _vm.update },
              }),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }